import axios from 'axios'
import { AdUnitIdResultBean, DspControllerApi } from 'common/api/api'
import { BaseApi, configuration } from 'common/api/BaseApi'
import { processError } from 'common/api/fetch'

class DspAxiosCall extends BaseApi {
  api: DspControllerApi

  constructor() {
    super()
    this.api = new DspControllerApi(configuration, configuration.basePath, this.fetch)
  }

  updateZoneAdUnitIds(dspId: number, csv: any): Promise<AdUnitIdResultBean> {
    const data = new FormData()
    data.append('csv', csv)
    return axios
      .post(configuration.basePath + '/api/dsp/' + dspId + '/adUnitId', data, { withCredentials: true })
      .then((res) => Promise.resolve(res.data))
      .catch((err) => processError(err))
  }
}

const dspAxiosCall = new DspAxiosCall()

export default dspAxiosCall
